import { render, staticRenderFns } from "./SitchThemeSelector.vue?vue&type=template&id=35b51861&scoped=true&"
import script from "./SitchThemeSelector.vue?vue&type=script&lang=ts&"
export * from "./SitchThemeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SitchThemeSelector.vue?vue&type=style&index=0&id=35b51861&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b51861",
  null
  
)

export default component.exports